"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLIENT_TYPE_POLICYHOLDER = exports.CLIENT_TYPE_AGENT = void 0;
var CLIENT_TYPE_AGENT = exports.CLIENT_TYPE_AGENT = "agent";
var CLIENT_TYPE_POLICYHOLDER = exports.CLIENT_TYPE_POLICYHOLDER = "policyholder";